<template>
  <div class="mb-4 bg-white px-6 py-8">
    <div
      class="flex items-center justify-between cursor-pointer mb-4"
      v-on="isDefaultView ? {} : { click: onCategoryExpand }"
    >
      <div class="font-bold">
        <span>{{ category.name }}</span>
        <span v-if="activeCategoriesCount > 0">&nbsp;({{ activeCategoriesCount }})</span>
      </div>
      <button
        v-if="!isDefaultView"
        class="ltr:ml-4 rtl:mr-4"
        :class="{ 'transform rotate-180': !state.isSliderActive }"
      >
        <span class="icon-chevron-down text-2xs text-secondary" />
      </button>
    </div>
    <div ref="sliderRef">
      <ul class="swiper-wrapper flex" :class="{ 'flex-wrap -m-2': !state.isSliderActive }">
        <li v-for="childCategory in categoriesFiltered"
            :key="childCategory.slug"
            class="swiper-slide"
            :class="{ 'm-2': !state.isSliderActive }"
        >
          <button class="disabled:opacity-30 disabled:cursor-default text-secondary border border-blue-dark transition-colors duration-300 py-2 px-5"
                  :class="{
                    'text-white bg-secondary': childCategory.active
                  }"
                  @click="onChangeCategory(childCategory)"
          >
            {{ getChildCategoryName(childCategory) }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SearchCategorySingleMobileBase from './SearchCategorySingleMobileBase.vue'

export default {
  extends: SearchCategorySingleMobileBase
}
</script>
